/**
 * Popup window features for share dialogs.
 * Sizes and centers the popup so the full content (including top) is visible.
 */
export function getSharePopupFeatures(): string {
  if (typeof window === 'undefined') {
    return 'width=560,height=680,scrollbars=yes,resizable=yes';
  }
  const w = 560;
  const h = Math.min(680, Math.floor(window.outerHeight * 0.85));
  const left = Math.max(0, Math.floor((window.outerWidth - w) / 2));
  const top = Math.max(0, Math.floor((window.outerHeight - h) / 2));
  return `width=${w},height=${h},left=${left},top=${top},scrollbars=yes,resizable=yes`;
}
